const TOKEN_KEY = 'vivo_auth_token';
const USER_KEY = 'vivo_user_data';

export class StorageUtil {
  static setToken(token: string): void {
    localStorage.setItem(TOKEN_KEY, token);
  }

  static getToken(): string | null {
    return localStorage.getItem(TOKEN_KEY);
  }

  static removeToken(): void {
    localStorage.removeItem(TOKEN_KEY);
  }

  static setUserData(userData: { msisdn: string; id: string }): void {
    localStorage.setItem(USER_KEY, JSON.stringify(userData));
  }

  static getUserData(): { msisdn: string; id: string } | null {
    const data = localStorage.getItem(USER_KEY);
    return data ? JSON.parse(data) : null;
  }

  static removeUserData(): void {
    localStorage.removeItem(USER_KEY);
  }

  static clear(): void {
    this.removeToken();
    this.removeUserData();
  }
}

